import React from "react";

function TableFooter({ isMobile, footerGroups }) {
  return (
    <React.Fragment>
      {!isMobile ? (
        <tfoot>
          {footerGroups.map((group) => (
            <tr key={group.id} {...group.getFooterGroupProps()}>
              {group.headers.map((column) => (
                <td key={column.id} {...column.getFooterProps()}>
                  {column.render("Footer")}
                </td>
              ))}
            </tr>
          ))}
        </tfoot>
      ) : (
        <tfoot>
          {footerGroups.map((group, index) => (
            <div key={index}>
              <div className="p-2 font-weight-bold text-center text-uppercase">
                Total Hours
              </div>
              <tr key={group.id} {...group.getFooterGroupProps()}>
                {group.headers.map((column) => (
                  <td key={column.id} {...column.getFooterProps()}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            </div>
          ))}
        </tfoot>
      )}
    </React.Fragment>
  );
}

export default TableFooter;
